import { SCREENS, GAME_ID, NUM_STANDARD_BACKGROUNDS } from '../data/constants';

export const initialState = {
  screen: SCREENS.PROGRESS,
  isProgress: true,
  isLoading: false,
  isOnboarding: false,
  isHelp: false,
  isStandard: false,
  isPractice: false,
  bgIndexes: [],
  currentBgIndex: null,
};

const sceneReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case 'WORDBOTS_CHANGE_SCENE': {
      const screen = action.payload;

      return {
        ...state,
        screen,
        isProgress: screen === SCREENS.PROGRESS,
        isLoading: screen === SCREENS.LOADING,
        isOnboarding: screen === SCREENS.ONBOARDING || screen === SCREENS.HELP,
        isHelp: screen === SCREENS.HELP,
        isStandard: screen === SCREENS.STANDARD,
        isPractice: screen === SCREENS.PRACTICE,
      };
    }

    case 'WORDBOTS_INIT_BACKGROUNDS': {
      const { bgIndexes } = action.payload;

      return {
        ...state,
        bgIndexes,
      };
    }

    case 'WORDBOTS_SET_CURRENT_BACKGROUND': {
      const { level } = action.payload;

      return {
        ...state,
        currentBgIndex: state.bgIndexes[level % NUM_STANDARD_BACKGROUNDS],
      };
    }

    default:
      return state;
  }
};

export default sceneReducer;
